export default __webpack_public_path__ + "static/spatiul-verde-d-953247c4dd005e1c0b2cee459acc7c21.jpg";